import { call, put, select } from 'redux-saga/effects';
import { isTheLast2SecondsInBettingTimeSelector } from 'core/widgets/BettingTime';
import { roundStateSelector } from 'core/widgets/RoundStates';
import { IRoundState, RoundStates } from 'core/widgets/RoundStates/types';
import { clearDoubleBetAction } from 'core/widgets/BetDouble/actions';
import { clearRepeatBetAction } from 'core/widgets/BetRepeat/actions';
import { ICreatePendingBetRequestData, RestService } from 'services/RestAPIService';
import { setTotalBetAction } from 'core/widgets/User/actions';
import * as Sentry from '@sentry/react';
import { updateBetsSaga } from './createPendingBetSaga';
import { updatePlacedBetsAction } from '../actions';
import { EMPTY_BET } from '../data';

export function* cancelAllBetsSaga() {
  const isTheLast2SecondsInBettingTime: boolean = yield select(
    isTheLast2SecondsInBettingTimeSelector,
  );
  const roundState: IRoundState['roundState'] = yield select(roundStateSelector);

  if (!isTheLast2SecondsInBettingTime) {
    yield call(updateBetsSaga, {
      past: [],
      present: EMPTY_BET,
    });
    yield put(clearDoubleBetAction());
    yield put(clearRepeatBetAction());
  }

  if (isTheLast2SecondsInBettingTime) {
    if (roundState === RoundStates.BettingTimeStarted) {
      const betsData: ICreatePendingBetRequestData = {
        bets: [],
        timeStamp: new Date().getTime(),
      };

      try {
        const response: ICreatePendingBetRequestData = yield call(() =>
          RestService.createPendingBet(betsData),
        );

        yield put(setTotalBetAction(0));
        yield put(updatePlacedBetsAction({ past: [], present: EMPTY_BET }));
      } catch (error) {
        Sentry.captureException({ error, betsData });
        console.log(error);
      }
    }
  }
}
